import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import { useDispatch } from 'react-redux'
import { expenseClaimRequestCreate } from 'redux/actions/expenseClaimRequestActions'
import { ExpenseClaimItemDetails, Profile } from '../../components/forms'
import { useRequest } from '../../RequestProvider'

const ExpenseClaimRequest = () => {
  const dispatch = useDispatch()

  const {
    setOnSubmit,
    setInitialValues,
    vars: { id, employee },
    drawerToggle,
    actionCallback,
  } = useRequest()

  const onSubmit = (val) => {
    const data = {
      ...val,
      ecr_items_attributes: val.ecr_items_attributes.map((item) => ({
        ...item,
        ecr_attachments_attributes: [item.ecr_attachments_attributes],
      })),
    }
    return dispatch(expenseClaimRequestCreate(id, data)).then(() => {
      drawerToggle()
      if (actionCallback) {
        actionCallback()
      }
    })
  }

  React.useEffect(() => {
    setOnSubmit(onSubmit)
    setInitialValues({
      title: 'test title',
      reason: '',
      ecr_items_attributes: [{}],
    })

    return () => {
      setOnSubmit(() => {})
      setInitialValues({})
    }
  }, [])

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      <Profile employee={employee} />
      <ExpenseClaimItemDetails />
    </Flex>
  )
}

export default ExpenseClaimRequest
